module.exports = __webpack_public_path__ + "static/media/screenshot_extended_ru.2f5ccba3.png";